// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

ion-content {
  flex: 1;
}

.customer-menu-list {
  padding: 8px;
}
.customer-menu-list ion-item {
  --border-radius: 8px;
  margin-bottom: 2px;
  font-size: 1rem;
}
.customer-menu-list ion-icon {
  font-size: 22px;
  margin-inline-end: 16px;
}
.customer-menu-list ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.18);
  font-weight: 600;
}
.customer-menu-list ion-item.selected ion-icon {
  color: var(--kiwi-accent-text);
}`, "",{"version":3,"sources":["webpack://./src/app/components/core/customer-side-menu/customer-side-menu.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAAF;;AAGA;EACE,OAAA;AAAF;;AAGA;EACE,YAAA;AAAF;AAEE;EACE,oBAAA;EACA,kBAAA;EACA,eAAA;AAAJ;AAGE;EACE,eAAA;EACA,uBAAA;AADJ;AAKE;EACE,sDAAA;EACA,gBAAA;AAHJ;AAKI;EACE,8BAAA;AAHN","sourcesContent":["// content of the ion-menu (right) in app.component.html\n:host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\nion-content {\n  flex: 1;\n}\n\n.customer-menu-list {\n  padding: 8px;\n\n  ion-item {\n    --border-radius: 8px;\n    margin-bottom: 2px;\n    font-size: 1rem;\n  }\n\n  ion-icon {\n    font-size: 22px;\n    margin-inline-end: 16px;\n  }\n\n  // the page of the entry is open\n  ion-item.selected {\n    --background: rgba(var(--ion-color-primary-rgb), 0.18);\n    font-weight: 600;\n\n    ion-icon {\n      color: var(--kiwi-accent-text);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
